<!-- #################### OLD MAIN VIEW #################### -->
<div *ngIf="!sidebar">
	<div
		class="searchWrapper old d-flex"
		[ngClass]="{
			'activeOperation': activeOperation,
			'isOpen': showBody
		}"
	>

		<div class="d-flex flexWrapper">
			<i
				class="operator-icon icon-magnifier vertical-separator--right"
				(click)="toggleBodyVisibility()"
			></i>

			<div
				class="operator-title"
				(click)="toggleBodyVisibility()"
			>
				<span>{{ getI18nString( false, 'shared.listOperations.search' ) }}</span>
			</div>

			<div class="operator-body">

				<!-- Input Group -->
				<div
					class="d-flex search-input-group"
					[ngClass]="{
						'focused': isFocused
					}"
				>

					<!-- Input -->
					<input
						#searchInput
						tabindex="0"
						type="text"
						[attr.autofocus]="isFocused"
						[title]="getI18nString( false, placeholderI18nPath, true, '' )"
						[(ngModel)]="search"
						(focusin)="isFocused = true"
						(focusout)="isFocused = false"
						(ngModelChange)="onInputChange($event)"
					/>

					<!-- Actions -->
					<div class="d-flex input-actions">

						<div *ngIf="showClearButton">
							<i
								class="input-group-text ft-x"
								(click)="clearControlValue()"
							></i>
						</div>

						<div *ngIf="showRevertButton">
							<i
								class="input-group-text icon-action-undo"
								(click)="revertControlValue()"
							></i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- #################### NEW MAIN VIEW #################### -->
<div *ngIf="sidebar" class="searchWrapper sidebar d-flex">

	<i class="operator-icon icon-magnifier vertical-separator--right"></i>

	<div class="operator-body">
		<!-- Input Group -->
		<div
			class="d-flex search-input-group"
			[ngClass]="{
				'focused': isFocused
			}"
		>

			<!-- Input -->
			<input
				#searchInput
				tabindex="0"
				type="text"
				[title]="getI18nString( false, placeholderI18nPath, true, '' )"
				[(ngModel)]="search"
				(focusin)="isFocused = true"
				(focusout)="isFocused = false"
				(ngModelChange)="onInputChange($event)"
			/>

			<!-- Actions -->
			<!-- TODO: add title attributes -->
			<div class="d-flex input-actions">

				<div *ngIf="showClearButton">
					<i
						class="input-group-text ft-x"
						(click)="clearControlValue()"
					></i>
				</div>

				<div *ngIf="showRevertButton">
					<i
						class="input-group-text icon-action-undo"
						(click)="revertControlValue()"
					></i>
				</div>
			</div>
		</div>
	</div>
</div>
